{
  "components": {
    "teams": {
      "noTeams": "You have no teams created yet.",
      "title": "My Teams",
      "membersCount": "{{count}} members",
      "activeTasksCount": "{{count}} active tasks",
      "other": "Other",
      "recentlySelected": "Recently selected",
      "searchPlaceholder": "Find team",
      "newTeam": "New Team",
      "editTeam": "Edit",
      "deleteTeam": "Delete",
      "confirmDeleteTeamDialog": {
        "confirmation": {
          "title": "Delete team",
          "description": "Are you sure you want to delete {{teamName}} team?",
          "cancel": "Cancel",
          "confirm": "Delete",
          "successMessage": "Team {{teamName}} deleted successfully",
          "errorMessage": "An error occurred while deleting the team {{teamName}}"
        }
      }
    },
    "team": {
      "teamForm": {
        "header": {
          "edit": "Edit Team",
          "create": "Create Team"
        },
        "submitButton": {
          "edit": "Save",
          "create": "Create"
        },
        "cancelButton": "Cancel",
        "removeMember": "Remove",
        "details": "Details",
        "inviteNewMember": "Invite new",
        "teamNamePlaceholder": "Team name",
        "teamSubtitlePlaceholder": "Team subtitle",
        "membersSelected_one": "{{count}} member selected",
        "membersSelected_other": "{{count}} members selected",
        "manageMembers": {
          "title": "Manage Members",
          "descriptionPrefix": "Manage members of the ",
          "descriptionSuffix": " team",
          "inviteNew": "Invite new"
        }
      },
      "teamUpperSection": {
        "sortSection": {
          "tasks": "Tasks",
          "sortBy": "Sort by:",
          "options": {
            "dueDate": "Due date",
            "priority": "Priority",
            "AssignedPersons": "Assigned persons",
            "TaskType": "Task type",
            "organizations": "Organizations"
          }
        }
      }
    }
  },
  "notifications": {
    "success": {
      "TEAM_CREATION_SUCCESS": {
        "description": "Team has been created successfully"
      },
      "TEAM_EDIT_SUCCESS": {
        "description": "Team has been edited successfully"
      },
      "TEAM_MEMBERS_UPDATE_SUCCESS": {
        "description": "Team members have been updated successfully"
      }
    }
  }
}
